import { render } from "./NewUsedBookTab.vue?vue&type=template&id=58b474e0"
import script from "./NewUsedBookTab.vue?vue&type=script&lang=js"
export * from "./NewUsedBookTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Products/NewUsedBookTab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "58b474e0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('58b474e0', __exports__)) {
    api.reload('58b474e0', __exports__)
  }
  
  module.hot.accept("./NewUsedBookTab.vue?vue&type=template&id=58b474e0", () => {
    api.rerender('58b474e0', render)
  })

}


export default __exports__